export default {
  "name": "NCTreeTable",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCTreeTable",
  "label": "树状表格",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "区域编码",
        "type": "string"
      },
      "async": {
        "title": "是否异步",
        "description": "是否异步",
        "type": "boolean",
        "default": false
      },
      "showCheckBox": {
        "title": "是否需要复选框",
        "description": "是否需要复选框",
        "type": "boolean",
        "default": false
      },
      "isDrag": {
        "title": "是否可拖拽",
        "description": "是否可拖拽",
        "type": "boolean",
        "default": true
      },
      "isLazyload": {
        "title": "是否显示查询按钮",
        "description": "是否显示查询按钮",
        "type": "boolean",
        "default": true
      },
      "adaptionHeight": {
        "title": "是否自适应高度",
        "description": "是否自适应高度",
        "type": "boolean",
        "default": true
      },
      "otherAreaHeight": {
        "title": "其他区域高度",
        "description": "其他区域高度",
        "type": "number"
      },
      "multipleRowCell": {
        "title": "是否显示多行",
        "description": "是否显示多行",
        "type": "boolean",
        "default": false
      },
      "addBlankCol": {
        "title": "是否增加空白列",
        "description": "是否增加空白列",
        "type": "boolean",
        "default": true
      },
      "bodyExpandAllInRow": {
        "title": "多行展示是否显示全部内容",
        "description": "多行展示是否显示全部内容",
        "type": "boolean"
      },
      "inModal": {
        "title": "是否在弹窗内",
        "description": "是否在弹窗内",
        "type": "boolean",
        "default": false
      },
      "disableRowClickSelect": {
        "title": "行点击是否勾选",
        "description": "行点击是否勾选",
        "type": "boolean"
      },
      "hideExpandAll": {
        "title": "隐藏右键菜单全部展开",
        "description": "隐藏右键菜单全部展开",
        "type": "boolean"
      },
      "hideIncludeChild": {
        "title": "隐藏右键菜单包含下级",
        "description": "隐藏右键菜单包含下级",
        "type": "boolean"
      },
      "visible": {
        "title": "是否可见",
        "description": "是否可见",
        "type": "boolean"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}